export const languages = [
  { href: "https://knswindows.com/", locale: "en", name: "English" },
  { href: "https://knsokna.pl/", locale: "pl", name: "Polski" },
  { href: "https://knsfenster.de/", locale: "de", name: "Deutsch" },
  { href: "https://kns-okna.eu/", locale: "cs", name: "Čeština" },
  { href: "https://knsfinestre.it/", locale: "it", name: "Italiano" },
  { href: "https://knsfenetres.fr/", locale: "fr", name: "Français" },
  { href: "https://knsokna.eu/", locale: "hu", name: "Magyar" },
];

export const locales = {
  CS: "https://kns-okna.eu",
  DE: "https://knsfenster.de",
  EN: "https://knswindows.com",
  FR: "https://knsfenetres.fr",
  HU: "https://knsokna.eu",
  IT: "https://knsfinestre.it",
  PL: "https://knsokna.pl",
};

export const partners = [
  { name: "veka" },
  { name: "decco" },
  // { name: 'deceuninck' },
  { name: "aluplast" },
  { name: "reynaers" },
  // { name: 'heroal' },
  { name: "aluron" },
  { name: "aluprof" },
  { name: "hueck" },
  { name: "gealan" },
  { name: "gu" },
  // { name: 'maco' },
  { name: "pressglass" },
  { name: "roto" },
  { name: "siegenia" },
  { name: "effectglass" },
  { name: "glassolutions" },
  { name: "termglas" },
];
